module.exports = __webpack_public_path__ + "img/n-pi-img-1.67a51abe.png";